define(["exports", "draft-js", "react", "react-focus-on", "styled-components", "../../themes"], function (_exports, _draftJs, _react, _reactFocusOn, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var Button = _styledComponents.default.button.withConfig({
    displayName: "CustomOption__Button",
    componentId: "sc-1ktry5h-0"
  })(["", ";width:100%;line-height:18px;&:focus{", "}"], _themes.resetButton, _themes.focusBoxShadow);

  var CustomOption = function CustomOption(_ref) {
    var editorState = _ref.editorState,
        onChange = _ref.onChange,
        customVariableLabel = _ref.customVariableLabel,
        variables = _ref.variables;

    var _useState = (0, _react.useState)(false),
        dropdownIsOpen = _useState[0],
        setDropdownIsOpen = _useState[1];

    var addHighLightVariable = function addHighLightVariable(e, type) {
      var contentState = editorState.getCurrentContent();
      var contentStateWithEntity = contentState.createEntity('MARK', 'IMMUTABLE', {
        type: 'MARK',
        text: type.toUpperCase()
      });
      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

      var text = _draftJs.Modifier.replaceText(contentState, editorState.getSelection(), "{{" + type.toUpperCase() + "}}", editorState.getCurrentInlineStyle(), entityKey);

      onChange(_draftJs.EditorState.push(editorState, text, 'insert-characters'));
      handleClose();
    };

    var handleClose = function handleClose() {
      setDropdownIsOpen(false);
    };

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "rdw-dropdown-wrapper rdw-block-dropdown",
      "aria-label": "rdw-dropdown",
      "aria-expanded": dropdownIsOpen
    }, /*#__PURE__*/_react.default.createElement(Button, {
      className: "rdw-dropdown-select-variable",
      onClick: function onClick() {
        return setDropdownIsOpen(!dropdownIsOpen);
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, customVariableLabel), /*#__PURE__*/_react.default.createElement("div", {
      className: !dropdownIsOpen ? 'rdw-dropdown-carettoopen' : 'rdw-dropdown-carettoclose'
    })), dropdownIsOpen && /*#__PURE__*/_react.default.createElement(_reactFocusOn.FocusOn, {
      onClickOutside: handleClose,
      onEscapeKey: handleClose
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "rdw-dropdown-optionwrapper rdw-dropdown-custom"
    }, variables.map(function (item) {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "rdw-dropdownoption-default",
        key: item.type
      }, /*#__PURE__*/_react.default.createElement(Button, {
        onClick: function onClick(e) {
          return addHighLightVariable(e, item.type);
        }
      }, item.label));
    }))));
  };

  var _default = CustomOption;
  _exports.default = _default;
});